export const CSS_CLASS: Readonly<Record<string, string>> = {
  CLOSE: 'react-modal-Close',
  MODAL: 'react-modal',
  CONTENT_WRAP: 'react-modal-content-wrapper',
  HEADER: 'react-modal-ProductSelectorHeader',
  CONTENT: 'react-modal-Content',
  OVERLAY: 'react-modal-Overlay',
  OVERLAY_CLEAR: 'react-modal-Overlay--clear',
  FOOTER: 'react-modal-Footer',
  REMOVE_SCROLL: 'react-modal-Html-remove-scroll'
}
